import React, { useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import PropTypes from 'prop-types';
import 'react-quill/dist/quill.snow.css';

const TextEditor = ({ value, onChange, placeholder, className }) => {
    const [editorValue, setEditorValue] = useState('');
    const editorRef = useRef();

    useEffect(() => {
        setEditorValue(value);
        // eslint-disable-next-line
    }, []);

    const modules = {
        toolbar: {
            container:
            [
                // [{ 'placeholder': ['[GuestName]', '[HotelName]'] }], // my custom dropdown
                ['bold', 'italic', 'underline', 'strike', 'link', 'image', 'formula'],        // toggled buttons
                ['blockquote', 'code-block'],
    
                [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
                [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
                [{ 'direction': 'rtl' }],                         // text direction
    
                [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    
                [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                [{ 'font': [] }],
                [{ 'align': [] }],
    
                ['clean']                                    // remove formatting button
               
            ],
        }
    };

    const handleTextChange = (value) => {
        setEditorValue(value);
        onChange(value);
    };

    return (
        <ReactQuill 
            ref={editorRef} 
            modules={modules} 
            theme="snow" 
            value={editorValue ? editorValue : ''} 
            onChange={handleTextChange} 
            placeholder={placeholder} 
            className={className}
        />
    );
};

TextEditor.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    className: PropTypes.string
};

export default TextEditor;